import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/catastro/valores-de-terreno-y-construccion/';

/**
 * GET Tipos Documentos Traslacion
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getValoresDeTerrenoYConstruccion = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET valoresDeTerrenoYConstruccion
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getValorDeTerrenoYConstruccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST valoresDeTerrenoYConstruccion
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postValorDeTerrenoYConstruccion = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH valoresDeTerrenoYConstruccion
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchValorDeTerrenoYConstruccion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE valoresDeTerrenoYConstruccion
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteValorDeTerrenoYConstruccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
